import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { LanguageContext } from '../contexts/LanguageContext';
import { ThemeContext } from '../contexts/ThemeContext';

const TestimonialCard = ({ quote, author, position, delay = 0 }) => {
  return (
    <div 
      className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-t-4 border-gradient-to-r from-blue-600 to-teal-500 overflow-hidden relative"
      data-aos="fade-up"
      data-aos-delay={delay}
    >
      <div className="absolute top-0 right-0 -mt-4 -mr-4 w-16 h-16 bg-gradient-to-r from-blue-500 to-teal-400 opacity-10 rounded-full"></div>
      <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-24 h-24 bg-gradient-to-r from-indigo-500 to-blue-400 opacity-10 rounded-full"></div>
      
      <svg className="w-12 h-12 text-gray-200 mb-4" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
        <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z"/>
      </svg>
      
      <p className="text-gray-700 dark:text-gray-200 text-lg leading-relaxed italic mb-6">{quote}</p>
      
      <div className="border-t pt-4 mt-2">
        <h4 className="font-bold text-gray-800 dark:text-gray-100 text-lg">{author}</h4>
        <p className="text-blue-600 dark:text-blue-400 font-medium">{position}</p>
      </div>
    </div>
  );
};

const CustomerStories = () => {
  const { translations } = useContext(LanguageContext);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      mirror: false,
      easing: 'ease-out-cubic'
    });
    
    return () => {
      AOS.refresh();
    };
  }, []);

  const testimonials = [
    {
      quote: translations['customerStories.testimonial1.quote'],
      author: translations['customerStories.testimonial1.author'],
      position: translations['customerStories.testimonial1.position']
    },
    {
      quote: translations['customerStories.testimonial2.quote'],
      author: translations['customerStories.testimonial2.author'],
      position: translations['customerStories.testimonial2.position']
    },
    {
      quote: translations['customerStories.testimonial3.quote'],
      author: translations['customerStories.testimonial3.author'],
      position: translations['customerStories.testimonial3.position']
    }
  ];

  return (
    <section className="py-20 bg-white dark:bg-gradient-to-b dark:from-gray-900 dark:to-gray-950">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="fade-up">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white mb-6">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-teal-500">{translations['customerStories.title']}</span>
          </h2>
          <p className="text-gray-700 dark:text-gray-200 text-lg max-w-3xl mx-auto leading-relaxed">
            {translations['customerStories.subtitle']}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard 
              key={index} 
              {...testimonial} 
              delay={index * 100}
            />
          ))}
        </div>
        
        <div className="text-center" data-aos="zoom-in">
          <div className="bg-gradient-to-r from-blue-600 to-teal-500 p-1 rounded-lg inline-block shadow-lg">
            <Link 
              to="/customer-stories" 
              className="inline-block bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-white font-bold px-8 py-4 rounded-lg transition transform hover:scale-[1.03]"
            >
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-teal-500">
                {translations['customerStories.viewAll']}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerStories;